import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EndpointColoredIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#ff9e0e' : this.getColor()
    return [
      <g>
        <path fill={ color } d="M34.24,16.25c-1-1-2.44-.44-3.42-1.42s-.44-2.44-1.42-3.41S27,11,26,10s-.26-2.49-1.31-3.53S22.2,6.2,21.15,5.16,20.8,2.7,19.79,1.69A2.86,2.86,0,0,0,18,1H4A3,3,0,0,0,1,4V32a3,3,0,0,0,3,3H32a3,3,0,0,0,3-3V18.24A3.5,3.5,0,0,0,34.24,16.25Z"/>
        <circle fill={ color } cx="28.1" cy="7.9" r="1.5"/>
        <circle fill={ color } cx="33" cy="7.9" r="1"/>
        <circle fill={ color } cx="33" cy="12.7" r="1.5"/>
        <circle fill={ color } cx="32.9" cy="3.1" r="0.5"/>
        <circle fill={ color } cx="28.1" cy="3.1" r="1"/>
        <circle fill={ color } cx="23.3" cy="3.1" r="1.5"/>
        <path fill={ '#fff' } d="M20.35,21.32a1,1,0,0,1-1-1V19a1.93,1.93,0,0,0-2.11-1.67h0A1.9,1.9,0,0,0,15.12,19v1.3a1,1,0,0,1-2,0V19a3.89,3.89,0,0,1,4.08-3.65h0A3.91,3.91,0,0,1,21.35,19v1.28A1,1,0,0,1,20.35,21.32Z"/>
        <path fill={ '#fff' } d="M20.83,29.7h-7.2a1.87,1.87,0,0,1-1.87-1.87v-4A1.87,1.87,0,0,1,13.63,22h7.2a1.87,1.87,0,0,1,1.87,1.86v4A1.87,1.87,0,0,1,20.83,29.7Zm-7.07-2H20.7V24H13.76Z"/>
        <g id="Path_2004" data-name="Path 2004">
          <path fill={ '#fff' } d="M9.81,26.59H9.62a6.88,6.88,0,0,1-5.57-6.91,7,7,0,0,1,6.75-7h.08a7.37,7.37,0,0,1,1.14.13A7.37,7.37,0,0,1,18.75,8.4H19a7.46,7.46,0,0,1,7.2,7.67c0,.12,0,.25,0,.37a5.29,5.29,0,0,1,2.95,5.23v0a5.66,5.66,0,0,1-4.29,4.85,1,1,0,0,1-.47-1.95,3.66,3.66,0,0,0,2.77-3.12A3.28,3.28,0,0,0,24.76,18l-1.09-.31.44-1a1.19,1.19,0,0,0,.09-.53V16A5.45,5.45,0,0,0,19,10.4h-.2a5.38,5.38,0,0,0-5.15,3.85l-.29,1-1-.31a5.58,5.58,0,0,0-1.51-.27,5,5,0,0,0-4.78,5h0v0a4.87,4.87,0,0,0,4,4.91,1,1,0,0,1,.79,1.17A1,1,0,0,1,9.81,26.59Z"/>
        </g>
      </g>
    ]
  }
  getViewBox = () => '0 0 36 36'
}
